import * as React from 'react'

import { cn } from '@/lib/utils'

interface GeneralV1HomepageShellProps {
  children: React.ReactNode
  className?: string
}

/**
 * Scoped theme/chrome/body wrapper for general-v1 template.
 *
 * Applies `data-template="general-v1"` and the `.theme-general-v1`
 * class to scope CSS custom properties. Constrains body content to the
 * design-system content width (1232px).
 *
 * Header and footer live OUTSIDE this shell — they are siblings managed
 * by NonFsdsHomepageWithTemplate.
 */
export default function GeneralV1HomepageShell({
  children,
  className,
}: GeneralV1HomepageShellProps) {
  return (
    <main
      id="main-content"
      data-template="general-v1"
      className={cn('theme-general-v1 min-h-screen bg-[var(--gv1-bg-surface)]', className)}
    >
      {children}
    </main>
  )
}
